/**
 * Query Store Feature Module
 *
 * Registers the `query-store` workspace type (SQL Server Query Store history
 * and regression comparison for one database). Registration side effect only —
 * the tab component stays behind the lazy chunk.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'query-store',
  lazyWorkspaceTab(() => import('./components/QueryStoreTab').then((m) => ({ default: m.QueryStoreTab }))),
);
